import type { GaApp } from '~/modules/app'

import { endpoints } from './endpoints'
import { MainRepository } from './main.repository'

export const repositories = (gaApp: GaApp) => ({
  main: new MainRepository(gaApp, endpoints),
})
